
let accessToken: string | null = localStorage.getItem('access_token') || null
let refreshToken: string | null = localStorage.getItem('refresh_token') || null

export const authStore = {
  getAccessToken: () => accessToken,
  getRefreshToken: () => refreshToken,

  setTokens: (access: string, refresh: string) => {
    accessToken = access
    refreshToken = refresh
    localStorage.setItem('access_token', access)
    localStorage.setItem('refresh_token', refresh)
  },

  clear: () => {
    accessToken = null
    refreshToken = null
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')
  },
  setUser: (user: any) => {
    localStorage.setItem('user', JSON.stringify(user))
  },
    getUser: () => {
        const user = localStorage.getItem('user')
        return user ? JSON.parse(user) : null
    },
}
